module.exports = __webpack_public_path__ + "img/260720945_2_9.e8f7ca38.png";